export const studioLabels = {
  EMEA: "System 1",
  APAC: "System 2",
  Americas: "System 3"
};

export const eventTechnicians = [
  'Amos Tse',
  'Brad Crosby',
  'Christopher Morrissey',
  'Dan Lock',
  'Jen Wright',
  'Jordan Moll',
  'Joshua Roberts',
  'Julian Gomez',
  'Nazry Zakaria',
  'Ryan Meyer',
  'William White',
]
